import {Action, createReducer, createSelector, on, SelectorWithProps} from '@ngrx/store';
import {Change, ChangelogState} from '@wba/store/models/changelog.state';
import {ChangelogLoadSuccessAction} from '@wba/store/actions/changelog.action';
import {EinkommenSchluesselEnum} from '@wba/models/enums/einkommen-typ.enum';
import {AppState} from '@wba/store/models/app-state';


const initialState: ChangelogState = {};


const changelogReducers = createReducer(initialState,
  on(ChangelogLoadSuccessAction, (state, {changelog}) => ({...changelog})),
);

export function reducer(state: ChangelogState | undefined, action: Action) {
  return changelogReducers(state, action);
}

const selectChangelogState = (state: AppState): ChangelogState => state.changelog;
export const selectChangelog = createSelector(
  selectChangelogState,
  (changelog: ChangelogState) => changelog
);


export interface ChangelogFilterProps {
  /**
   * NOTE - for future stories:
   * Currently only the Einkommensarten have a key and are present in the `changelog.json`
   * Append additional keys for the remaining application here.
   */
  type: EinkommenSchluesselEnum;
  formVersionSaved: number;
}

export const showChangelog: SelectorWithProps<AppState, ChangelogFilterProps, boolean> = createSelector(
  selectChangelogState,
  (state: ChangelogState, {type, formVersionSaved}: ChangelogFilterProps): boolean => {
    return formVersionSaved < state[type].latestVersion;
  }
);

export const selectChangelogForTypeAndVersion = createSelector(
  selectChangelogState,
  (state: ChangelogState, {type, formVersionSaved}: ChangelogFilterProps): Change[] => {
    if (Object.entries(state).length === 0 || !type || formVersionSaved === null) {
      return [];
    }

    return state[type].changelog
      .filter(e => e.version > formVersionSaved)
      .map(e => e.changes)
      .flat();
  }
);
